module.exports = __webpack_public_path__ + "static/media/android-chrome-192x192.83af0e68.png";